import { render } from "./EventLabel.vue?vue&type=template&id=6667ae59"
import script from "./EventLabel.vue?vue&type=script&lang=js"
export * from "./EventLabel.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__